import * as Sentry from '@sentry/vue'
import router from '@/router'
import SlideMixpanelTracker from '@/utils/mixpanel/slide.mixpanel-tracker'
import PresentationMixpanelTracker from '@/utils/mixpanel/presentation.mixpanel-tracker'
import util from '@/util'

/**
 * Tracks slide creation events for newly created slides from chatbot
 * @param {Array} newSlides - Array of newly created slides
 * @param {Object} presentation - Current presentation object
 */
export const trackChatbotSlideCreation = (newSlides, presentation) => {
  if (!newSlides?.length || !presentation) {
    return
  }

  try {
    const routeName = router?.currentRoute?.name
    if (!routeName) {
      return
    }

    const slideTracker = new SlideMixpanelTracker(presentation, routeName)
    const presentationTracker = new PresentationMixpanelTracker(presentation)
    const eventLabel = 'AI chatbot'

    // Track each new slide individually
    newSlides.forEach((slide) => {
      const slideTypeName = util.getCorrectSlideTypeName(slide?.type, slide?.slideType)

      slideTracker.setCustomProps({
        ...presentationTracker.getPresentationContext(),
        slideId: slide?.id,
        slide_type: slideTypeName,
      })

      slideTracker.trackCreateNewSlide(eventLabel, null, true) // useGA4Tracking = true
    })
  } catch (error) {
    // Log tracking errors but don't disrupt the main flow
    Sentry.captureException(error, {
      tags: { component: 'chatbot-slide-tracking' },
      extra: {
        newSlidesCount: newSlides.length,
        routeName: router?.currentRoute?.name,
        presentationId: presentation.id,
      },
    })
  }
}
